module.exports = __webpack_public_path__ + "img/01.d00b7765.png";